import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "../../../Components/layout";
import logo from "../../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import MtnZaService from "../../../Utilies/Utilies/MtnZaService";
import checkIcon from "../../../assets/imgs/check.png";
import "./MtnzaStatus.css";

const MtnzaStatus = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");
  const [iconPath, setIconPath] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    const urlParams = Object.fromEntries(searchParams.entries());
    
    if (Object.keys(urlParams).length > 0) {
      const trafficsource = localStorage.getItem("trafficsource");
      const parameter = localStorage.getItem("parameter");

      MtnZaService.check({
        ...urlParams,
        company: trafficsource || null,
        key: parameter || null,
      })
        .then((response) => {
          console.log("Check response:", response);
           if (response.data.token) {
          localStorage.setItem("user_id", response?.data?.user?.id);
          // store token to local storage
          localStorage.setItem("token", response?.data?.token);
          localStorage.setItem(
            "userImage",
            JSON.stringify(response?.data?.user?.avatar)
          );
          setTimeout(() => {
            navigate("/", { replace: true });
            window.location.reload();
          }, 3000);
        }
        })
        .catch((error) => {
          console.error("Check error:", error);
        });
    }

    const statusParam = searchParams.get("status");
    setStatus(statusParam);
    handleStatusMessage(statusParam);
  }, [searchParams]);

  const handleStatusMessage = (statusParam) => {
    if (statusParam === "ACTIVE") {
      setMessage("Subscription success.");
      setIconPath(checkIcon);
      
      let phoneNumber = localStorage.getItem("msisdn") || "";
      if (!phoneNumber.startsWith("27")) {
        phoneNumber = "27" + phoneNumber;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "trackerEvent",
        msisdn: "+" + phoneNumber,
      });
    } else if (statusParam === "FAILED") {
      setMessage("Subscription failed. Please try again.");
      setIconPath(null);
    } else if (statusParam === "ACTIVATION_DECLINED_BY_USER") {
      setMessage("The activation process was declined by you.");
      setIconPath(null);
    } else {
      setMessage("");
      setIconPath(null);
    }
  };

  return (
    <Layout>
      <img className="servImg mb-4" src={logo} alt="" />

      <div className="mtnza-status-content">
        <div className="status text-center">
          {iconPath && (
            <img src={iconPath} alt="status icon" className="status-icon mb-3" />
          )}
          {message && <p className="text-white">{message}</p>}
          
          
        </div>
      </div>
    </Layout>
  );
};

export default MtnzaStatus;
